import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPackWidgets } from '../actions';
import styled from 'styled-components';
import WidgetCell from './WidgetCell';

const WidgetListWrapper = styled.ul`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    padding: 0;
    list-style: none;
`;

function WidgetsList({ pack = {}, widgets = {}, listWidgets = [], getPackWidgets, isResetPackWidgets = 0 }) {
    getPackWidgets(pack._id, pack.widgets);

    return (
        <WidgetListWrapper>
            {listWidgets.map(widgetId => (
                <WidgetCell
                    key={`${widgetId}${isResetPackWidgets}`}
                    widget={widgets[widgetId]}
                    isChecked={pack.widgets.indexOf(widgets[widgetId].id) !== -1}
                />
            ))}
        </WidgetListWrapper>
    );
}

WidgetsList.propTypes = {
    // From connect
    pack: PropTypes.object.isRequired,
    widgets: PropTypes.object.isRequired,
    listWidgets: PropTypes.array.isRequired,
    isResetPackWidgets: PropTypes.number,
    getPackWidgets: PropTypes.func.isRequired,
};

export default connect(
    ({ packs, requery = { entities: { packs: {}, widgets: {} }, list: { widgets: {} } } }, { packId }) => ({
        pack: Object.values(requery.entities.packs).find(pack => pack.id === packId) || {},
        widgets: requery.entities.widgets || {},
        listWidgets: requery.list.widgets || [],
        isResetPackWidgets: packs.resetPackWidgets || 0,
    }),
    { getPackWidgets },
)(WidgetsList);



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/WidgetsList.js
 **/